module.exports = __webpack_public_path__ + "static/media/arrow-open-pop.41d684aa.svg";